export const TRACKING_CENSUSES: Record<string, { trade: string; total: number; hollow: number; percentage: string; advertisers: number; adsHollow?: number; adsPercentage?: string }> = {
  roofing: { trade: "roofing", total: 297, hollow: 219, percentage: "73.7%", advertisers: 62, adsHollow: 21, adsPercentage: "33.9%" },
  electricians: { trade: "electrical", total: 326, hollow: 274, percentage: "84.0%", advertisers: 50, adsHollow: 28, adsPercentage: "56.0%" },
  painting: { trade: "painting", total: 233, hollow: 190, percentage: "81.5%", advertisers: 28 },
  concrete: { trade: "concrete", total: 190, hollow: 154, percentage: "81.1%", advertisers: 20 },
  landscaping: { trade: "landscaping", total: 239, hollow: 184, percentage: "77.0%", advertisers: 19 },
  "pest-control": { trade: "pest control", total: 213, hollow: 163, percentage: "76.5%", advertisers: 39, adsHollow: 16, adsPercentage: "41.0%" },
  cleaning: { trade: "house cleaning", total: 165, hollow: 124, percentage: "75.2%", advertisers: 31, adsHollow: 11, adsPercentage: "35.5%" },
  plumbing: { trade: "plumbing", total: 251, hollow: 183, percentage: "72.9%", advertisers: 55, adsHollow: 23, adsPercentage: "41.8%" },
  remodeling: { trade: "remodeling", total: 195, hollow: 134, percentage: "68.7%", advertisers: 46, adsHollow: 9, adsPercentage: "19.6%" },
  "window-replacement": { trade: "window", total: 172, hollow: 113, percentage: "65.7%", advertisers: 42, adsHollow: 7, adsPercentage: "16.7%" },
  hvac: { trade: "HVAC", total: 230, hollow: 138, percentage: "60.0%", advertisers: 68, adsHollow: 18, adsPercentage: "26.5%" },
  "pool-service": { trade: "pool service", total: 284, hollow: 152, percentage: "53.5%", advertisers: 46, adsHollow: 11, adsPercentage: "23.9%" },
};

export function hollowDotIndices(total: number, hollow: number): Set<number> {
  const indices = Array.from({ length: total }, (_, index) => index);
  let seed = (total * 7 + hollow) >>> 0;
  for (let i = total - 1; i > 0; i--) {
    seed = (Math.imul(seed, 1664525) + 1013904223) >>> 0;
    const j = seed % (i + 1);
    const current = indices[i];
    const other = indices[j];
    if (current === undefined || other === undefined) continue;
    indices[i] = other;
    indices[j] = current;
  }
  return new Set(indices.slice(0, hollow));
}

export function numberInWords(n: number): string {
  const ones = ["zero", "one", "two", "three", "four", "five", "six", "seven", "eight", "nine", "ten", "eleven", "twelve", "thirteen", "fourteen", "fifteen", "sixteen", "seventeen", "eighteen", "nineteen"];
  const tens = ["", "", "twenty", "thirty", "forty", "fifty", "sixty", "seventy", "eighty", "ninety"];
  if (n < 20) return ones[n] ?? String(n);
  if (n < 100) return `${tens[Math.floor(n / 10)]}${n % 10 ? `-${ones[n % 10]}` : ""}`;
  return `${ones[Math.floor(n / 100)]} hundred${n % 100 ? ` ${numberInWords(n % 100)}` : ""}`;
}